import { render, staticRenderFns } from "./updateOrCreatePlace.vue?vue&type=template&id=e55d467a"
import script from "./updateOrCreatePlace.vue?vue&type=script&lang=js"
export * from "./updateOrCreatePlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports